<template>
  <q-list no-border highlight separator>
    <team-member-list-entry
      v-for="(member, index) in members"
      :key="'member' + index"
      :member="member"
    />

    <team-invite-list-entry
      v-if="showInvites"
      v-for="(invite, index) in invites"
      :key="'invite' + index"
      :invite="invite"
    />
  </q-list>
</template>

<script>
  import TeamInviteListEntry from './TeamInviteListEntry.vue'
  import TeamMemberListEntry from './TeamMemberListEntry.vue'

  export default {
    props: {
      team: {
        type: Object,
        required: true
      },

      showInvites: {
        type: Boolean,
        default: true
      },

      showReadOnly: {
        type: Boolean,
        default: false
      }
    },

    computed: {
      members () {
        return this.showReadOnly
          ? this.team.members
          : this.team.members.filter(m => m.role_id < 3)
      },

      invites () {
        return this.showReadOnly
          ? this.team.invites
          : this.team.invites.filter(m => m.role_id < 3)
      }
    },

    components: {
      TeamInviteListEntry,
      TeamMemberListEntry
    }
  }
</script>

<style lang="stylus">
  .q-item
    .team-list-entry__controls
      display: none
    &:hover, &.hovered
      .team-list-entry__controls
        display: initial
</style>
